<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24"
       fill="none" stroke="currentColor" :stroke-width="strokeWidth"
       stroke-linecap="round" stroke-linejoin="round" class="yn-svg-icon yn-svg-icon-chevron-left">
    <polyline points="15 18 9 12 15 6" />
  </svg>
</template>
<script setup>
defineProps({ size: [Number,String], strokeWidth: [Number,String] })
</script>
